import React, { useState } from 'react';
import { auth } from '../assets/firebaseConfig';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import backgroundImage from '../assets/SkyBackground.jpg';
import AppstralLogIn from '../assets/AppstralLogIn.svg';
import AppstralLogo from '../assets/AppstralLogo.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AboutModal from './AboutModal';
import RegisterModal from './RegisterModal';
const ForgotPasswordModal = ({ show, onClose, t }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setIsLoading(true);

    try {
      // Usamos el 'auth' importado para enviar el correo
      await sendPasswordResetEmail(auth, email);
      setMessage(t('forgotPasswordModal.successMessage'));
      setEmail('');
    } catch (err) {
      console.error('Error al enviar correo de restablecimiento:', err.message);
      if (err.code === 'auth/user-not-found' || err.code === 'auth/missing-email') {
        setError(t('forgotPasswordModal.userNotFound'));
      } else if (err.code === 'auth/invalid-email') {
        setError(t('forgotPasswordModal.invalidEmail'));
      } else {
        setError(t('forgotPasswordModal.genericError'));
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Estilos adaptados de tu SuscribeModal
  const currentOverlayStyle = {
    ...modalOverlayStyle,
    opacity: show ? 1 : 0,
    pointerEvents: show ? 'auto' : 'none',
  };

  const currentContentStyle = {
    ...modalContentBaseStyle,
    backgroundColor: '#f8f9fa',
    borderRadius: '0.625rem',
    maxWidth: '40vw',
    position: 'relative',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Función para cerrar y limpiar estados
  const handleClose = () => {
    setEmail('');
    setMessage('');
    setError('');
    setIsLoading(false);
    onClose();
  };

  return (
    <div style={currentOverlayStyle} onClick={handleOverlayClick}>
      <div className="delete-account-modal-content">
        <p
          style={{
            fontSize: '20px',
            textAlign: 'center',
            color: '#4d4d4d',
            fontWeight: '300',
            width: '80%',
            margin: '30px auto',
          }}
        >
          {t('forgotPasswordModal.instruction')}
        </p>

        {message ? (
          <p style={{ color: 'green', fontWeight: 'bold' }}>{message}</p>
        ) : (
          <form onSubmit={handleResetPassword}>
            <div className="delete-account-form-group">
              <input
                type="email"
                placeholder={t('loginPage.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="deleteInput"
                disabled={isLoading}
              />
            </div>
            {error && <p style={{ color: 'red', fontSize: '0.875rem' }}>{error}</p>}
            <div className="delete-account-buttons-container">
              <button type="button" onClick={handleClose} className="delete-account-button-cancel">
                Cancelar
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className="delete-account-button-cancel"
                style={{ borderBottomRightRadius: '12px' }}
              >
                {isLoading ? t('forgotPasswordModal.loading') : t('forgotPasswordModal.sendButton')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { t, i18n } = useTranslation();
  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('appLang', lng);
  };
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    setProgress(0);
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 90) {
          return prevProgress + 10;
        }
        return prevProgress;
      });
    }, 100);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      clearInterval(interval);
      setProgress(100);
      navigate('/');
    } catch (err) {
      clearInterval(interval);
      setProgress(0);
      if (
        err.code === 'auth/invalid-credential' ||
        err.code === 'auth/wrong-password' ||
        err.code === 'auth/user-not-found'
      ) {
        setError('Tu correo o contraseña es incorrecto.');
      } else if (err.code === 'auth/invalid-email') {
        setError('Formato de correo electrónico inválido.');
      } else {
        setError('Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.');
        console.error('Error al iniciar sesión:', err.message);
      }
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setProgress(0);
      }, 500);
    }
  };
  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        paddingBottom: '2.5rem',
        alignItems: 'center',
        color: 'white',
        textAlign: 'center',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '1.5rem',
          right: '1.75rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontFamily: 'Effra',
          fontSize: '0.95rem',
          zIndex: 5,
        }}
      >
        {['es', 'en'].map((lng, index) => (
          <React.Fragment key={lng}>
            {index > 0 && <span style={{ color: 'white', opacity: 0.4 }}>|</span>}
            <span
              onClick={() => changeLang(lng)}
              style={{
                cursor: 'pointer',
                color: 'white',
                fontWeight: (i18n.language || '').startsWith(lng) ? 600 : 300,
                opacity: (i18n.language || '').startsWith(lng) ? 1 : 0.5,
                transition: 'opacity 0.2s ease',
              }}
            >
              {lng.toUpperCase()}
            </span>
          </React.Fragment>
        ))}
      </div>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '1rem', justifyContent: 'center' }}
        onSubmit={handleLogin}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={AppstralLogIn}
            style={{ width: '3.125rem', fill: 'white' }}
            alt={t('loginPage.AppstralLogInAlt')}
          />
          <img
            src={AppstralLogo}
            style={{ height: '3.125rem' }}
            alt={t('loginPage.appstralLogoAlt')}
          />
          <h1 style={{ fontSize: '1em' }}>{t('loginPage.slogan')}</h1>
        </div>
        <div
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            borderRadius: '0.625rem',
            width: '21.875rem',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: 'auto',
            boxShadow: '0 0 0.9375rem rgba(0, 0, 0, 0.5)',
          }}
        >
          <h2
            style={{
              fontFamily: 'Effra',
              fontWeight: 300,
              marginTop: '1.875rem',
              fontSize: '1.5rem',
              color: 'white',
              marginBottom: '0',
            }}
          >
            {t('loginPage.loginTitle')}
          </h2>
          <input
            type="email"
            placeholder={t('loginPage.emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="my-input"
            disabled={isLoading}
          />
          <input
            type="password"
            placeholder={t('loginPage.passwordPlaceholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="my-input"
            disabled={isLoading}
          />
          <span
            style={{
              fontFamily: 'Effra',
              fontWeight: 300,
              color: '#7ebcec',
              magin: '0',
              fontWeight: 'normal',
              cursor: 'pointer',
            }}
            onClick={() => setShowForgotPasswordModal(true)}
          >
            {t('loginPage.forgotPassword')}
          </span>
          <h2
            style={{
              fontFamily: 'Effra',
              fontWeight: 300,
              fontSize: '0.875rem',
              color: 'white',
              margin: '0 auto 25px',
            }}
          >
            {t('loginPage.notMemberPart1')}{' '}
            <span
              style={{ color: '#7ebcec', fontWeight: 'normal', cursor: 'pointer' }}
              onClick={() => setShowRegisterModal(true)}
            >
              {t('loginPage.subscribeHere')}
            </span>
          </h2>
          {error && <p style={{ color: 'red', fontSize: '0.875rem' }}>{error}</p>}
        </div>
        <div style={{ justifyContent: 'center' }}>
          <button
            type="submit"
            className="login-button"
            style={{
              padding: '0.625rem 2.1875rem',
              color: 'white',
              border: 'none',
              borderRadius: '1.25rem',
              fontFamily: 'Effra',
              fontSize: '1em',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.3s ease',
              position: 'relative',
              overflow: 'hidden',
              width: 'fit-content',
            }}
            disabled={isLoading}
          >
            {isLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: `${progress}%`,
                  backgroundColor: '#333333',
                  opacity: 0.5,
                  transition: 'width 0.1s ease-out',
                  zIndex: 1,
                }}
              ></div>
            )}
            <span
              style={{
                position: 'relative',
                zIndex: 2,
                color: 'white',
              }}
            >
              {t('loginPage.loginButtonText')}
            </span>
          </button>
        </div>
      </form>
      <div
        style={{
          position: 'absolute',
          bottom: '0.9375rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.35rem',
        }}
      >
        <span
          onClick={() => setShowAboutModal(true)}
          style={{
            fontFamily: 'Effra',
            fontWeight: 300,
            fontSize: '0.875rem',
            color: '#7ebcec',
            cursor: 'pointer',
          }}
        >
          {t('loginPage.aboutLink')}
        </span>
        <p
          style={{
            fontFamily: 'Effra',
            fontWeight: 300,
            fontSize: '0.875rem',
            color: 'white',
            margin: 0,
          }}
        >
          {t('loginPage.footerCopyright')}
        </p>
      </div>
      <RegisterModal
        show={showRegisterModal}
        t={t}
        i18n={i18n}
        onClose={() => setShowRegisterModal(false)}
      />
      <ForgotPasswordModal
        show={showForgotPasswordModal}
        t={t}
        onClose={() => setShowForgotPasswordModal(false)}
      />
      <AboutModal show={showAboutModal} onClose={() => setShowAboutModal(false)} />
    </div>
  );
}
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
};
const modalContentBaseStyle = {
  backgroundColor: 'white',
  padding: '2rem',
  borderRadius: '0.5rem',
  textAlign: 'center',
  color: 'black',
  boxShadow: '0 0.25rem 0.625rem rgba(0, 0, 0, 0.2)',
  transform: 'scale(0.8)',
  transition: 'transform 0.2s ease-in-out',
};
const modalButtonStyle = {
  marginTop: '1rem',
  padding: '0.5rem 1rem',
  backgroundColor: '#7ebcec',
  color: 'white',
  border: 'none',
  borderRadius: '0.25rem',
  cursor: 'pointer',
  fontSize: '1em',
};
export default Login;
